export const ACTION_LABELS = {
  created: 'Criação',
  updated: 'Alteração',
  deleted: 'Exclusão',
  restored: 'Restauração',
};

export const ACTION_CLASSES = {
  created: 'bg-emerald-50 text-emerald-800 ring-emerald-200',
  updated: 'bg-sky-50 text-sky-800 ring-sky-200',
  deleted: 'bg-rose-50 text-rose-800 ring-rose-200',
  restored: 'bg-amber-50 text-amber-800 ring-amber-200',
};

export function formatAuditDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleString('pt-BR');
}

export function formatActor(item) {
  return item?.actor_name || item?.actor_email || item?.deleted_by_name || item?.actor_id || 'Sistema';
}

export function formatValue(value) {
  if (value == null || value === '') return '—';
  if (typeof value === 'boolean') return value ? 'sim' : 'não';
  if (typeof value === 'object') {
    try {
      return JSON.stringify(value);
    } catch {
      return String(value);
    }
  }
  return String(value);
}
